/**
 * Dashboard statistics models
 */

/**
 * Complete dashboard statistics response
 */
export interface DashboardStats {
  overview: OverviewStats;
  statusBreakdown: StatusBreakdown[];
  contentFormatBreakdown: ContentFormatBreakdown[];
  topTags: TagStats[];
  topGroups: GroupStats[];
  monthlyTrends: MonthlyTrend[];
  contentStats: ContentStats;
  excerptStats: ExcerptStats;
  recentActivity: RecentActivityPost[];
  postTypeBreakdown: PostTypeBreakdown[];
  insights?: Insights;
  topAuthors?: TopAuthor[];
  contentMetrics?: ContentMetrics;
}

/**
 * Overview statistics
 */
export interface OverviewStats {
  totalPosts: number;
  publishedPosts: number;
  myPosts: number;
  authorCount: number;
}

/**
 * Breakdown by publish status
 */
export interface StatusBreakdown {
  status: string;
  count: number;
}

/**
 * Breakdown by content format
 */
export interface ContentFormatBreakdown {
  format: string;
  count: number;
}

/**
 * Tag usage statistics
 */
export interface TagStats {
  tag: string;
  count: number;
}

/**
 * Group usage statistics
 */
export interface GroupStats {
  group: string;
  count: number;
}

/**
 * Monthly posting trends
 */
export interface MonthlyTrend {
  year: number;
  month: number;
  count: number;
  published: number;
}

/**
 * Content length statistics
 */
export interface ContentStats {
  avgLength: number;
  maxLength: number;
  minLength: number;
}

/**
 * Excerpt and meta description statistics
 */
export interface ExcerptStats {
  postsWithExcerpt: number;
  postsWithAutoExcerpt: number;
  postsWithoutExcerpt: number;
  postsWithMetaDescription: number;
  postsWithAutoMetaDescription: number;
}

/**
 * Recent activity post item
 */
export interface RecentActivityPost {
  _id: string;
  title: string;
  publishStatus: string;
  createdAt: string;
  author?: {
    name: string;
  };
}

/**
 * Breakdown by post type
 */
export interface PostTypeBreakdown {
  typeName: string;
  count: number;
}

/**
 * Key insights and metrics
 */
export interface Insights {
  publishRate: number;
  averagePostsPerAuthor: number;
  userContribution: number;
  mostActiveMonth: string;
}

/**
 * Top author statistics
 */
export interface TopAuthor {
  authorId: string;
  authorName: string;
  totalPosts: number;
  publishedPosts: number;
  lastPostDate?: string;
}

/**
 * Content metrics (legacy compatibility)
 */
export interface ContentMetrics {
  averageLength: number;
  maxLength: number;
  minLength: number;
}
